import { useIsAuthenticated, useLogin } from "@refinedev/core";
import { useState } from "react";
import { Navigate, useLocation } from "react-router";

import { returnPath } from "@/lib/loginReturn";

type LoginVars = { password: string };

/**
 * Дверь. Одно поле, и ни слова о том, как завести пароль.
 *
 * Заводят и отзывают пароль в CRM, поэтому здесь нет ни регистрации, ни
 * восстановления: ссылка на них была бы обещанием, которого этот экран не
 * исполняет. Логина нет тоже — пароль сам называет, кто пришёл.
 */
export function LoginPage() {
  const { data: auth } = useIsAuthenticated();
  const { mutate: login, isPending } = useLogin<LoginVars>();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { search } = useLocation();

  if (auth?.authenticated) return <Navigate to={returnPath(search)} replace />;

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    login(
      { password },
      {
        onSuccess: (result) => {
          if (!result.success)
            setError(result.error?.message ?? "Не удалось войти");
        },
      },
    );
  };

  return (
    <div className="grid h-screen place-items-center bg-bg px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-[340px] rounded-[var(--radius-card)] border border-border bg-bg-subtle p-6"
      >
        <div className="mb-5 flex items-center gap-2.5">
          <div className="grid size-6 place-items-center rounded-[5px] bg-fg text-[13px] font-semibold text-bg">
            S
          </div>
          <div className="text-[15px] font-semibold tracking-[-0.015em]">
            supply
          </div>
        </div>

        <h1 className="mb-1 text-[17px] font-semibold tracking-[-0.02em]">
          Вход в кабинет закупки
        </h1>
        <p className="mb-5 text-[12.5px] text-fg-muted">
          Пароль — тот же, что в CRM.
        </p>

        <label
          className="mb-1.5 block text-[12px] text-fg-muted"
          htmlFor="password"
        >
          Пароль
        </label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4 h-9 w-full rounded-[var(--radius-ui)] border border-border bg-bg px-2.5 text-[13.5px] outline-none focus:border-border-strong"
        />

        {error ? (
          <div
            role="alert"
            className="mb-3.5 rounded-[var(--radius-ui)] border border-err/30 bg-err-bg px-3 py-2 text-[12.5px] text-err"
          >
            {error}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={isPending || password.length === 0}
          className="h-9 w-full rounded-[var(--radius-ui)] bg-fg text-[13.5px] font-medium text-bg disabled:opacity-60"
        >
          {isPending ? "Проверяем…" : "Войти"}
        </button>
      </form>
    </div>
  );
}
